import { render } from "./TransactionSingle.vue?vue&type=template&id=5b813b0c&scoped=true"
import script from "./TransactionSingle.vue?vue&type=script&lang=js"
export * from "./TransactionSingle.vue?vue&type=script&lang=js"

import "./TransactionSingle.vue?vue&type=style&index=0&id=5b813b0c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b813b0c"]])

export default __exports__